import { render, staticRenderFns } from "./OneAmerica.vue?vue&type=template&id=523aad46&"
import script from "./OneAmerica.vue?vue&type=script&lang=js&"
export * from "./OneAmerica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VFileInput})
